module.exports = __webpack_public_path__ + "img/yz3.8f97586c.png";